module.exports = __webpack_public_path__ + "img/logo_misrad_hinuh_3.0f4e7981.png";